import {useMemo, useState} from "react";
import moment from "moment";
import './QuestionDatePicker.css';
import {NassauLog} from "../../scripts/myga-utils";

const populateOptions = (minTime, maxTime, incValue, incUnit, timeFormat) => {
  let options = [];
  options.push(<option key={'time_noValue'} value=''>--</option>);
  let time = moment(minTime);
  let i = 0;
  while (time.toDate().getTime() <= maxTime.getTime()) {
    let str =  time.format(timeFormat);
    options.push(<option key={'time'+(i++)} value={str}>{str}</option>);
    time.add(incValue,incUnit);
  }
  return options;
}

export default function QuestionTimePicker(props) {
  const {required, question, handleChange, data, responseClass} = props;
  const {minTime, maxTime, incValue, incUnit, timeFormat} = question.response.constraints[0];
  const [selectedTime, setSelectedTime] = useState(data[question.key]?data[question.key]:'');

  const renderTimeSelector = useMemo(() => (value) => {
    const handleTimeValueChange = e => {
      handleChange(question.key)(e.target.value);
      setSelectedTime(e.target.value);
    }

    let options = populateOptions(minTime, maxTime, incValue, incUnit, timeFormat);
    return (
      <select className={'form-control time'}
              value={value}
              onChange={handleTimeValueChange}
              required={required}>
        {options}
      </select>
    )
  }, [handleChange, incUnit, incValue, maxTime, minTime, question.key, required, timeFormat]);

  const timeSelector = useMemo(() => {
    return renderTimeSelector(selectedTime)
  }, [selectedTime, renderTimeSelector]);

  return (
    <div className={`nsre-date-picker ${responseClass}`}>
      <div className={'row'}>
        <div className={'select-wrap col-12'}>
          {timeSelector}
          <div><label>time</label></div>
        </div>
      </div>
    </div>
  )
}